import React from 'react';
import { EventDocument } from 'interfaces/document.interface';
import { CommonGlobalService } from '@umanforge/common';


interface EventDocumentFileNameProps {
  file: EventDocument;
}

const EventDocumentFileName: React.FC<EventDocumentFileNameProps> = ( { file } ) => {

  const { name, extension } = CommonGlobalService.getFileNameInfo( file.originalName );

  return (
    <>
      <div
        className='flex h-full w-full px-1 py-0.5 justify-center text-center items-end text-sm text-nowrap'
      >
        <span className='w-fit truncate'>
          { name }
        </span>
        <span className='w-fit'>
          { extension }
        </span>
      </div>
    </>
  );
};

export default EventDocumentFileName;
